<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset.prevent="onReset"
    >
        <div class="row nopads px-2">
            <div class="col-sm-6">
                <span class="search-title">{{ $t('users.user_name') }}</span>
                <input
                    v-model="username"
                    class="form-control form-control-sm"
                    type="text"
                />
            </div>
            <div class="col-sm-6">
                <span class="search-title">{{ $t('users.email') }}</span>
                <input
                    v-model="email"
                    class="form-control form-control-sm"
                    type="text"
                />
            </div>
        </div>
        <div class="row nopads px-2">
            <div class="col-sm-6">
                <span class="search-title">{{ $t('users.first_name') }}</span>
                <input
                    v-model="firstName"
                    class="form-control form-control-sm"
                    type="text"
                />
            </div>
            <div class="col-sm-6">
                <span class="search-title">{{ $t('users.last_name') }}</span>
                <input
                    v-model="lastName"
                    class="form-control form-control-sm"
                    type="text"
                />
            </div>
        </div>


      <div class="row nopads px-2">
          <div class="col-sm-6">
              <span class="span-title">{{ $t('users.company') }}</span>
              <multiselect
                v-model="company"
                :options="companyOptions"
                :custom-label="value => value.name"
                :multiple="false"
                :close-on-select="true"
                label="key"
                track-by="name"
                :searchable="true"
                :internal-search="true"
                :selected-label="$t('common.selected')"
                :select-label="$t('common.select')"
                :deselect-label="$t('common.remove_selection')"
                :placeholder="$t('users.select_company')"
              >
                    <template
                      #singleLabel="props"
                    >
                      <span class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                      </span>
                    </template>
                    <template
                      #option="props"
                    >
                      <div class="option__desc">
                        <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                      </div>
                    </template>
                    <template #noResult>
                      <span>{{ $t('common.not_found') }}</span>
                    </template>
                    <template #noOptions>
                      <span>{{ $t('common.no_results') }}</span>
                    </template>
              </multiselect>
        </div>
          <div class="col-sm-6">
              <span class="span-title">{{ $t('users.license_holder_title') }}</span>
              <multiselect
                  v-model="licenseHolder"
                  :options="companyOptions"
                  :custom-label="value => value.name"
                  :multiple="false"
                  :close-on-select="true"
                  label="key"
                  track-by="name"
                  :searchable="true"
                  :internal-search="true"
                  :selected-label="$t('common.selected')"
                  :select-label="$t('common.select')"
                  :deselect-label="$t('common.remove_selection')"
                  :placeholder="$t('users.select_company')"
              >
                  <template
                      #singleLabel="props"
                  >
                      <span class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                      </span>
                  </template>
                  <template
                      #option="props"
                  >
                      <div class="option__desc">
                          <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                      </div>
                  </template>
                  <template #noResult>
                      <span>{{ $t('common.not_found') }}</span>
                  </template>
                  <template #noOptions>
                      <span>{{ $t('common.no_results') }}</span>
                  </template>
              </multiselect>
          </div>

      </div>

      <div class="col-sm-12 mt-2 d-flex justify-content-end">
          <button type="reset" class="btn btn-danger form-button">
              {{ $t('ins_report.clear') }}
          </button>
        <button type="submit" class="btn btn-primary form-button">
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'UserSearch',
    mixins: [restApi],
    props: {
        isObserver: Boolean,
        user: null
    },
    data: function () {
        return {
            users: [],
            companyOptions: [],
            company: null,
            licenseHolder: null,
            username: null,
            email: null,
            firstName: null,
            lastName: null
        }
    },
    mounted: function () {
        this.fetchCompanies()
    },
    methods: {
        fetchCompanies: function () {
            this.companyOptions = []
            this.loading = true
            this.restFetch(this.companyUrl, this.handleCompanies)
        },
        handleCompanies: function (response) {
            if (response && response.data) {
                response.data.forEach(company => {
                    this.companyOptions.push({name: company.name, value: company.id})
                })
            }
            this.loading = false
        },
        onSubmit: function () {
            var params = {}
            if (this.username) {
                params.username = this.username
            }
            if (this.email) {
                params.email = this.email
            }
            if (this.firstName) {
                params.first_name = this.firstName
            }
            if (this.lastName) {
                params.last_name = this.lastName
            }
            if (this.company) {
                params.company = this.company.value
            }
            if (this.licenseHolder) {
                params.license_holder = this.licenseHolder.value
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.username = null
            this.email = null
            this.firstName = null
            this.lastName = null
            this.company = null
            this.licenseHolder = null
        }
    }
}
</script>

<style scoped>

</style>
